<app-grid
  #grid
  *ngIf="!loading"
  [columnDefs]="columnDef"
  [rowData]="rowData"
  [rowSelection]="showResults ? 'multiple' : 'single'"
  [selectedProject]="selectedProject"
  [suppressRowClickSelection]="showResults"
  [useSelectAll]="showResults && isProjectOwnershipValid"
  [signOffActionEnabled]="showResults && isProjectOwnershipValid"
  [pivotMode]="pivotEnabled"
  [pivotPanelShow]="'always'"
  [rowGroupPanelShow]="'always'"
  [groupDisplayType]="'multipleColumns'"
  [pagination]="!pivotEnabled"
  [sideBar]="sideBar"
  [allowDragFromColumnsToolPanel]="true"
  [autoGroupColumnDef]="autoGroupColumnDef"
  [groupDefaultExpanded]="-1"
  [gridOptions]="gridOptions"
  (onSelectedRowEvent)="onSelectedRowEvent($event)"
  (onSelectAllClicked)="onSelectedAllChanged()"
  (onBtnSignOffEvent)="onSignOffClicked()"
  (onFirstDataRenderedEvent)="onGridFirstDataRendered()"
/>

<app-loading *ngIf="loading"/>
